import React from "react"
import useWindowDimensions from "../../hooks/useWindowDimensions"
import { smWidth } from "../../static/sizes/widths"
import DesktopNav from "./components/Desktop"
import MobileNav from "./components/Mobile"

const Navigation = () => {
  const { width } = useWindowDimensions()

  return (
    <nav className="bg-igem-light-blue sticky z-30 top-0">
      {width && width > smWidth ? <DesktopNav /> : <MobileNav />}
    </nav>
  )
}

export default Navigation
